import type { ButtonData } from 'ricos-schema';
import {
  ButtonData_Type,
  Link_Target,
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
} from 'ricos-schema';

import type { NodeBuilder } from './types';
import { isDefined } from './utils';

export const button = (...args: (NodeBuilder | ButtonData)[]): NodeBuilder => {
  const buttonData = args.find(
    (a): a is ButtonData => a?.type === ButtonData_Type.LINK || a?.type === ButtonData_Type.ACTION
  );

  return {
    type: 'block_node',
    // @ts-ignore
    node: getId => {
      const nodes = args
        .map(arg => ('type' in arg && arg.type === 'block_node' ? arg.node(getId) : undefined))
        .filter(isDefined);
      return {
        id: getId(),
        type: Node_Type.BUTTON,
        ...(nodes?.length && { nodes }),
        buttonData: buttonData
          ? buttonData
          : {
              type: ButtonData_Type.LINK,
              containerData: {
                alignment: PluginContainerData_Alignment.CENTER,
                width: { size: PluginContainerData_Width_Type.ORIGINAL },
              },
              link: {
                url: '',
                target: Link_Target.BLANK,
                rel: { nofollow: true },
                anchor: undefined,
              },
              styles: {},
              text: 'Click Me',
            },
      };
    },
  };
};
